export default __webpack_public_path__ + "static/DNGResidential_3-19b354c7af3c8e28028e9475b754e2b4.jpg";